var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeatBreadLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.277,
    height: 24.679,
    viewBox: "0 0 16.277 24.679",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "beatBread_logo",
    "data-name": "beatBread logo",
    d: "M8.419,24.67H0V-.008H4.584V16.245s0,0,0,0,0,.008,0,.013a3.041,3.041,0,1,0,3.04-3.077A3,3,0,0,0,5.8,13.8V-.008H8.747a5.679,5.679,0,0,1,3.713,9.9A7.972,7.972,0,0,1,8.419,24.67Z",
    transform: "translate(0 0.008)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatBreadLogo);
export default __webpack_public_path__ + "static/media/beatBreadLogo.f4ea225e279669c8572d431d8b976717.svg";
export { ForwardRef as ReactComponent };